import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('hp_token'));
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const getHeaders = useCallback(() => ({
    headers: { Authorization: `Bearer ${token}` }
  }), [token]);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setUser(res.data))
        .catch(() => { localStorage.removeItem('hp_token'); setToken(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const signup = async (name, email, password, { is_creator, creator_name } = {}) => {
    const res = await axios.post(`${API}/auth/signup`, { name, email, password, is_creator, creator_name });
    localStorage.setItem('hp_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('hp_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('hp_token');
    setToken(null);
    setUser(null);
  };

  const refreshUser = async () => {
    if (token) {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data);
    }
  };

  // Use admin token when on admin routes
  const adminToken = localStorage.getItem('hp_admin_token');
  const isAdminRoute = location.pathname.startsWith('/ayo-panel');
  const activeToken = isAdminRoute && adminToken ? adminToken : token;

  return (
    <AuthContext.Provider value={{ user, token: activeToken, loading, signup, login, logout, refreshUser, getHeaders, API }}>
      {children}
    </AuthContext.Provider>
  );
}
